import type { ReactionModel } from './Reactions.types';
import { reactionsState } from './reactionsState';

export const deleteReactionFromSharedState = (payload: ReactionModel) => {
  const filteredReactions = reactionsState.value.reactions[
    payload.idModel
  ].filter(
    (reaction) =>
      reaction.idEmoji.toUpperCase() !== payload.idEmoji.toUpperCase() ||
      reaction.idMember !== payload.idMember,
  );
  reactionsState.setValue({
    ...reactionsState.value,
    reactions: {
      ...reactionsState.value.reactions,
      [payload.idModel]: filteredReactions,
    },
  });
};
